module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.editing && _vm.$route.name == 'cart.basket') ? _c('div', {
    key: "edit-notify",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner alerts-banner"
  }, [_c('div', {
    staticClass: "full-width blue"
  }, [_c('div', {
    staticClass: "price-subtotal"
  }, [_c('span', {
    staticClass: "text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.locale.text_editing_booking_warning.replace(':id', _vm.editing)) + "\n                                "), _c('a', {
    staticClass: "cta-button blue",
    attrs: {
      "id": "discard-booking-changes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.locale.button_editing_booking_discard_changes)
    },
    on: {
      "click": function($event) {
        _vm.cancelEdit()
      }
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.flash) ? _c('div', {
    key: "flash",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner alerts-banner"
  }, [_c('div', {
    staticClass: "full-width",
    class: {
      'dark-red': _vm.flash.type == 'danger', 'green': _vm.flash.type == 'success'
    }
  }, [_c('div', {
    staticClass: "price-subtotal"
  }, [(_vm.flash.message instanceof Array && _vm.flash.message.length == 1) ? _c('span', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.flash.message[0])
    }
  }) : (_vm.flash.message instanceof Array) ? _c('ul', _vm._l((_vm.flash.message), function(message) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(message)
      }
    })
  })) : _c('span', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.flash.message)
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-438db00f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FlashMessage.vue
// module id = 171
// module chunks = 0